export const PARAM_KEYS = {
  TOKEN: 'set',
  REFRESH: 'refresh',
}
